import { Box, Typography } from '@mui/material';
import * as React from 'react';

interface ViewerHeaderProps {
  // dadosServidor?: DadosServidor;
  title?: string;
  // totalQuestions: number;
  // answeredQuestions: number;
}

export const ViewerHeader: React.FC<ViewerHeaderProps> = ({
  // dadosServidor,
  title = 'Respostas do Questionário',
  // totalQuestions,
  // answeredQuestions,
}) => {
  return (
    <Box sx={{ pt: 2 }}>
      <Box
        sx={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          borderRadius: '8px',
          p: 1,
          mb: 2,
          ml: { xs: 2, md: 2 },
          mr: { xs: 2, md: 2 },
          textAlign: 'center',
        }}
      >
        <Typography
          sx={{
            color: '#ffffff',
            fontSize: { xs: '11pt', md: '12pt' },
            fontFamily: 'Roboto-Bold !important',
            letterSpacing: '0.8px',
            textTransform: 'uppercase',
          }}
        >
          {title}
        </Typography>
      </Box>

      {/* {dadosServidor && (
        <Box sx={{ mt: 5, px: { xs: 2, md: 3 } }}>
          <Paper
            elevation={0}
            sx={{
              maxWidth: 1175,
              mx: 'auto',
              p: { xs: 2.5, md: 3 },
              borderRadius: 2,
              backgroundColor: 'rgba(25, 118, 210, 0.08)',
              border: '1px solid rgba(25, 118, 210, 0.3)',
              position: 'relative',
              paddingLeft: '20px !important',
              '&::before': {
                content: '""',
                position: 'absolute',
                left: 0,
                top: 0,
                bottom: 0,
                width: '4px',
                backgroundColor: 'primary.main',
              },
            }}
          >
            <Typography
              variant="body1"
              sx={{
                pl: 1,
                pr: 1,
                color: 'text.primary',
                fontSize: { xs: '0.9rem', md: '1rem' },
                lineHeight: 1.8,
                textAlign: 'center',
                '& .destaque': {
                  fontWeight: 500,
                  color: 'primary.dark',
                },
              }}
            >
              <span className="destaque">
                {dadosServidor.nomeFuncionario || ''}
              </span>
              , você respondeu a pesquisa{' '}
              <span className="destaque">"FALA, PROFESSOR!"</span>, referente ao
              estabelecimento{' '}
              <span className="destaque">{dadosServidor.descEscola}</span>, no
              município de{' '}
              <span className="destaque">{dadosServidor.descMun}</span>,
              vinculado ao NRE{' '}
              <span className="destaque">{dadosServidor.descNre}</span>. Sua
              participação foi registrada pela função{' '}
              <span className="destaque">{dadosServidor.funcao}</span>.
              <br />
              <span style={{ color: '#6b7280' }}>
                Caso necessário, confira suas respostas no formulário abaixo.
              </span>
            </Typography>
          </Paper>
        </Box>
      )} */}
    </Box>
  );
};
